// The six lifecycle states (§3.5). Status lives at the DAY level ONLY.
// One hue per state, mutually exclusive (D5). Every state carries a label +
// a shape (D6). "The ball is with" is documentation, not rendered chrome.
export const STATUS = {
  unconfirmed: { label: 'Unconfirmed', ball: 'You' },
  confirmed: { label: 'Confirmed', ball: 'Nobody yet' },
  pending: { label: 'Pending approval', ball: 'Your approver' },
  approved: { label: 'Approved', ball: 'Done' },
  rejected: { label: 'Rejected', ball: 'You — and it failed' },
  notreq: { label: 'Not required', ball: 'Nobody, ever' },
}

export const STATUS_ORDER = ['unconfirmed', 'confirmed', 'pending', 'approved', 'rejected', 'notreq']
